<template>
  <div class="tooltip-wrap">
    <div class="tooltip-content" :class="type">
      <span v-html="text"></span>
    </div>
    <div class="tooltip-ico">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
      >
        <g id="ic_info_big" transform="translate(-528 -346)">
          <circle
            id="Ellipse_12"
            cx="8"
            cy="8"
            r="8"
            data-name="Ellipse 12"
            transform="translate(528 346)"
          />
          <rect
            id="Rectangle_108"
            width="2"
            height="5"
            class="cls-2"
            data-name="Rectangle 108"
            rx="1"
            transform="translate(535 353)"
          />
          <rect
            id="Rectangle_109"
            width="2"
            height="2"
            class="cls-2"
            data-name="Rectangle 109"
            rx="1"
            transform="translate(535 350)"
          />
        </g>
      </svg>
    </div>
  </div>
</template>

<style>
.cls-2 {
  fill: #fff;
}
</style>

<script>
export default {
  name: "RoeTooltip",
  props: {
    text: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: false,
      default() {
        return "top";
      }
    }
  }
};
</script>
